<template>
    <svg version="1.1" class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px"
        viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
        <path fill="currentColor" d="M32.15,6.96c0,0.47-0.4,0.87-0.87,0.87H8.96c-1.43,0-2.61,1.17-2.61,2.61v9.11c0,1.43,1.18,2.61,2.61,2.61
		h10.99l-5.07-5.08c-0.35-0.33-0.35-0.89,0-1.24c0.33-0.33,0.89-0.33,1.24,0l6.55,6.56c0.35,0.35,0.35,0.89,0,1.24l-6.55,6.56
		c-0.17,0.16-0.4,0.24-0.63,0.24c-0.23,0-0.44-0.09-0.61-0.24c-0.35-0.35-0.35-0.89,0-1.24l5.07-5.07H8.96
		c-2.4,0-4.35-1.97-4.35-4.35v-9.11c0-2.4,1.95-4.35,4.35-4.35h22.32C31.75,6.09,32.15,6.48,32.15,6.96z"/>
    </svg>
</template>
